export default __webpack_public_path__ + "static/laveLingeFaceMobile-11939073a16d3097877b7d15744da85b.png";